import { useState } from "react";
import ReactSlider from "react-slider";
import { toast } from "react-toastify";
import { Input } from "reactstrap";

const RangeSlider = ({ value, setValue, setCurrentPage, adminColor = "" }) => {
  const [inputValues, setInputValues] = useState(value);

  const handleInputChange = (e, index) => {
    const inputValue = e.target.value.trim();

    if (inputValue === "") {
      const newInputValues = [...inputValues];
      newInputValues[index] = 0;

      setInputValues(newInputValues);
      setValue(newInputValues);
      return;
    }

    const parsedValue = parseInt(inputValue);

    if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > 100) {
      setInputValues(value);
      return;
    }

    const newInputValues = [...inputValues];
    newInputValues[index] = parsedValue;

    if (index === 0) {
      if (newInputValues[0] > newInputValues[1]) {
        toast.error("First value should be smaller than the second value");
        setInputValues(inputValues);
        return;
      }
    } else {
      if (newInputValues[0] > newInputValues[1]) {
        newInputValues[0] = 0;
        setInputValues(newInputValues);
        setValue(newInputValues);
        return;
      }
    }

    setInputValues(newInputValues);
    setValue(newInputValues); // Update the value prop
  };

  const handleSliderChange = (newValue, index) => {
    setCurrentPage(0);
    setValue(newValue, index);
    setInputValues(newValue);
  };

  return (
    <>
      <div className="slider-div">
        <Input
          type="number"
          min={value[0]}
          max={value[1]}
          className="no-spin"
          value={inputValues[0]}
          onChange={(e) => handleInputChange(e, 0)}
          onBlur={(e) => handleInputChange(e, 0)} // Added onBlur event handler
        />
        <ReactSlider
          value={value}
          onChange={(value, index) => handleSliderChange(value, index)}
          onAfterChange={(value, index) => handleSliderChange(value, index)}
          className="horizontal-slider"
          thumbClassName="example-thumb"
          trackClassName="example-track"
          renderThumb={(props, state) => <div {...props}></div>}
           renderTrack={(props, state) => (
          <div
            {...props}
            style={{
              ...props.style,
              backgroundColor:
                state.index === 1
                  ? adminColor !== ""
                    ? adminColor
                    : "#0243ec"
                  : "#ddd",
            }}
          />
        )}
        />
        <Input
          type="number"
          min={value[0]}
          // max={value[1]}
          max={value[1]}
          className="no-spin"
          value={inputValues[1]}
          onChange={(e) => handleInputChange(e, 1)}
          onBlur={(e) => handleInputChange(e, 1)}
        />
      </div>
    </>
  );
};

export default RangeSlider;
